// import * as moment from 'moment';
// import qs from 'qs';

// import { addNumberDelimiterForPrice } from '../../utils/stringUtil';
import creditcards from 'creditcards';

const card = creditcards.card;

// プラン詳細取得の場合、gonにyadoId（jxxxxxx）とplanIdが必要
export function initAccommodationPayment() {

  const $ = (window as any).jQuery;

  $('.js-credit-number').on('input', () => {
    const cardNumber = $('.js-credit-number').val();
    const halfWidthCardNumber = formatNumber(cardNumber);
    $('.js-credit-number').val(card.format(card.parse(halfWidthCardNumber)));
  });

  $('.js-credit-expires').on('input', () => {
    const cardExpires = $('.js-credit-expires').val();
    const trimmedcardExpires = formatNumber(cardExpires);

    if (cardExpires.length === 4) {
      $('.js-credit-expires').val(trimmedcardExpires);
      return;
    }

    if (trimmedcardExpires.length >= 2) {
      const position = 2; // 月2桁
      const expiresWithSlash = [trimmedcardExpires.slice(0, position), ' / ', trimmedcardExpires.slice(position)].join('');
      $('.js-credit-expires').val(expiresWithSlash);
      return;
    } else {
      $('.js-credit-expires').val(trimmedcardExpires);
      return;
    }
  });
}

function formatNumber(str: string) {
  const onlyNumber = trimNotNumber(str);
  const halfWidthNumber = replaceFullWidthNumberToHalfWidthNumber(onlyNumber);
  return halfWidthNumber;
}

function trimNotNumber(str: string) {
  return str.replace(/[^0-9０-９]/g, '');
}

function replaceFullWidthNumberToHalfWidthNumber(str: string) {
  return str.replace(/０/g, '0').replace(/１/g, '1').replace(/２/g, '2').replace(/３/g, '3').replace(/４/g, '4')
    .replace(/５/g, '5').replace(/６/g, '6').replace(/７/g, '7').replace(/８/g, '8').replace(/９/g, '9');
}
